import { Controller } from "@hotwired/stimulus"
import { setHidden } from "../dom/visibility"

export default class extends Controller {
  static targets = ["unconfirmable", "error", "errorMessages", "loadingButton", "confirmButton"]

  static values = {
    stripePublishableKey: String,
    paymentApiReference: String,
    paymentIntentClientSecret: String,
    paymentMethodId: String,
    paymentIntentStatus: String,
    successPath: String
  }

  connect() {
    this.stripe = window.Stripe(this.stripePublishableKeyValue)
    this.render(this.isConfirmable() ? "confirmable" : "unconfirmable")
  }

  isConfirmable() {
    return Boolean(this.paymentMethodIdValue) && this.paymentIntentStatusValue === "requires_confirmation"
  }

  render(status) {
    setHidden(this.unconfirmableTarget, status !== "unconfirmable")
    setHidden(this.errorTarget, status !== "error")
    setHidden(this.loadingButtonTarget, status !== "loading")
    setHidden(this.confirmButtonTarget, status !== "confirmable")
  }

  async confirm() {
    this.render("loading")

    const result = await this.stripe.handleCardPayment(this.paymentIntentClientSecretValue)

    if (result.error) {
      this.reportFailure()
      this.showError(result.error.message)
    } else {
      window.location.replace(this.successPathValue)
    }
  }

  reportFailure() {
    fetch(`/api/v1/payments/${this.paymentApiReferenceValue}/failures`, {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json",
        "X-CSRF-Token": this.csrfToken,
        Accept: "application/json"
      },
      body: "{}"
    })
  }

  showError(message) {
    this.errorMessagesTarget.innerHTML = this.errorHtml(message)
    this.render("error")
  }

  errorHtml(message) {
    return `
      <div class="failure-state">
        <div class="failure-state__title-container">
          <div class="failure-state__icon"></div>
          <div class="failure-state__title">There was an issue with your payment.</div>
        </div>
        <div class="failure-state__msg">${this.escapeHtml(message)}</div>
      </div>
    `
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }

  get csrfToken() {
    const csrfMetaTag = document.querySelector("meta[name='csrf-token']")
    return csrfMetaTag ? csrfMetaTag.content : ""
  }
}
